import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { type Clip } from '@air/api/types';

import { updateCentralizedClipAction } from '~/store/centralizedClip/actions';
import { useUpdateAssetInAllViews } from '~/utils/mutateUtils/GalleryAssets';

export type UpdateStateAfterAddingOrRemovingDiscussionProps = {
  newCommentCount: number;
  newDiscussionCount: number;
  clipId: Clip['id'];
};

export const useUpdateStateAfterAddingOrRemovingDiscussion = () => {
  const dispatch = useDispatch();
  const { updateAssetInAllViews } = useUpdateAssetInAllViews();

  const updateStateAfterAddingOrRemovingDiscussion = useCallback(
    ({ clipId, newCommentCount, newDiscussionCount }: UpdateStateAfterAddingOrRemovingDiscussionProps) => {
      updateAssetInAllViews({
        asset: {
          id: clipId,
          openCommentCount: newCommentCount,
          openDiscussionCount: newDiscussionCount,
        },
      });
      dispatch(
        updateCentralizedClipAction({
          clip: {
            id: clipId,
            openDiscussionCount: newDiscussionCount,
            openCommentCount: newCommentCount,
          },
        }),
      );
    },
    [dispatch, updateAssetInAllViews],
  );

  return { updateStateAfterAddingOrRemovingDiscussion };
};
